import { createRouter, createMemoryHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 사업개요
  {
    path: '/overview',
    name: 'overview',
    component: () => import('../views/business/BusinessView.vue')
  },
  // 입지환경
  {
    path: '/location',
    name: 'location',
    component: () => import('../views/premium/PremiumView.vue')
  },
  // 프리미엄
  {
    path: '/premium',
    name: 'premium',
    component: () => import('../views/complex/ComplexView.vue')
  },
  // 오시는길
  {
    path: '/directions',
    name: 'directions',
    component: () => import('../views/sale/SaleView.vue')
  },
  // 관심고객등록
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/support/SupportView.vue')
  },
  // 관리자 페이지
  {
    path: '/adminmaruhill',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createMemoryHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 라우터 준비 후 어드민 URL 체크
router.isReady().then(() => {
  if (window.location.hash === '#/adminmaruhill') {
    router.push('/adminmaruhill')
  }
})

export default router
